<div class="ag-theme-quartz h-full w-full">
  @if (gridData(); as gridData) {
    <ag-grid-angular class="h-full w-full" [treeData]="true" [rowData]="gridData" [gridOptions]="gridOptions" />
  } @else {
    <div class="flex h-full w-full items-center justify-center">
      <ISpinner [display]="true" />
    </div>
  }
</div>
